import { useMemo } from 'react';

import SortButton from '@ui/buttons/sort-button/sort-button';
import { SortDirection } from '@ui/buttons/sort-button/types';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';

const CastHeaderColumn = ({
  name,
  onSortClick,
  activeSortOrder,
}: {
  name: string;
  onSortClick: (label: string, direction: SortDirection) => void;
  activeSortOrder?: { name: string; direction: SortDirection };
}) => {
  const direction = useMemo(() => {
    if (!activeSortOrder || activeSortOrder.name !== name) {
      return SortDirection.none;
    }
    return activeSortOrder.direction;
  }, [activeSortOrder, name]);

  return (
    <th>
      <Container className="flex ai-center" width="100%">
        <SortButton
          buttonProps={{
            padding: '0 6px',
            width: 'fit-content',
            height: 'fit-content',
            border: 'none',
            hoverBorder: 'none',
            backgroundColor: 'var(--gray-1000)',
            hoverBackgroundColor: 'var(--gray-700)',
          }}
          sortDirection={direction}
          PreContent={() => (
            <Text whiteSpace="nowrap" height="100%" className="L3 padding-r-6" design="GlobalIcoText3">
              {name}
            </Text>
          )}
          onClick={() => {
            const iterationOrder = [SortDirection.none, SortDirection.down, SortDirection.up];
            const idxOfOld = iterationOrder.indexOf(direction);
            const newDirection = iterationOrder[idxOfOld + 1] || iterationOrder[0];
            onSortClick(name, newDirection);
          }}
        />
      </Container>
    </th>
  );
};

export default CastHeaderColumn;
